import RestService from '../../contracts/RestService';
import '../../utils/http-client';
export var ASSET_CATEGORY;
(function (ASSET_CATEGORY) {
    ASSET_CATEGORY[ASSET_CATEGORY["IMAGE"] = 3] = "IMAGE";
    ASSET_CATEGORY[ASSET_CATEGORY["FONT"] = 1] = "FONT";
})(ASSET_CATEGORY || (ASSET_CATEGORY = {}));
export default class AssetService extends RestService {
    uri = 'assets';
    categories;
    constructor() {
        super();
        //this.fetchAllAssetCategories();
    }
    async fetchAllAssetCategories() {
        this.categories = await (await this.client.get('/assets/categories')).data;
    }
    async generateNames(names) {
        return this.client.post('/assets/cloud/generate', { names });
    }
    async deleteAsset(id) {
        return this.client.delete(`/assets/cloud/delete/${id}`);
    }
    async saveUploadedAsset(names, category) {
        return this.client.post('/assets/cloud/savegenerated', { names, category });
    }
    async loadImages(page = 1) {
        return this.client.get('/assets/user/sorted', { params: { page, category: ASSET_CATEGORY.IMAGE } });
    }
}
